import type { ReactNode } from 'react';

export function Card({
  title,
  className,
  children,
}: {
  title?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  return (
    <section className={['card', className ?? ''].filter(Boolean).join(' ')}>
      {title ? <h2 className="card-title">{title}</h2> : null}
      {children}
    </section>
  );
}
